import http from "@/http/aisea/axios";

const resource = "/enterprises/crews";

/**
 * 船員年度情報API
 */
export default {
  /**
   * 船員の年度情報一覧を取得
   * @param {String} enterpriseCrewId - 船員ID
   * @returns {Promise} APIレスポンス
   */
  fetch(enterpriseCrewId) {
    return http.get(`${resource}/${enterpriseCrewId}/fiscal_years`);
  },

  /**
   * 船員の年度情報を更新
   * @param {String} enterpriseCrewId - 船員ID
   * @param {String} enterpriseCrewFiscalYearId - 年度情報ID
   * @param {Object} payload - 更新データ
   * @returns {Promise} APIレスポンス
   */
  update(enterpriseCrewId, enterpriseCrewFiscalYearId, payload) {
    return http.put(
      `${resource}/${enterpriseCrewId}/fiscal_years/${enterpriseCrewFiscalYearId}`,
      payload
    );
  },
};
